import * as z from "zod/v4";

const shippingOverride = z.object({
  name: z.string(),
  address: z.object({
    line1: z.string(),
    line2: z.string().optional(),
    city: z.string(),
    state: z.string(),
    postal_code: z.string(),
    country: z.string(),
  }),
});

export const getCheckoutSession = {
  name: "getCheckoutSession" as const,
  input: z.object({ checkoutSessionId: z.string() }),
  output: z.object({
    id: z.string(),
    status: z.string().nullable(),
    clientSecret: z.string().nullable(),
    shippingOverride: shippingOverride.nullable(),
  }),
};
